export const muiRadioTheme = {
  MuiRadio: {
    styleOverrides: {
      root: ({ theme }) => ({
        '&.MuiRadio-root+.MuiTypography-root': {
          textTransform: 'uppercase',
          fontFamily: 'RF Rostin',
          fontStyle: 'normal',
          fontWeight: '700',
          fontSize: '14px',
          lineHeight: '120%',
          textAlign: 'center',
          letterSpacing: '-0.01em',
          color: theme.palette.kit.text.secondary,
        },
        '.MuiSvgIcon-root': {
          fill: 'currentColor',
          width: '1em',
          height: '1em',
        },
        '&.MuiRadio-root.Mui-checked': {
          color: theme.palette.kit.text.h,
        },
        '&.MuiRadio-root.Mui-checked+.MuiTypography-root': {
          color: theme.palette.kit.text.h,
        },
      }),
    },
  },
};
